import { render, staticRenderFns } from "./five.vue?vue&type=template&id=951c0082&scoped=true&"
var script = {}
import style0 from "./five.vue?vue&type=style&index=0&id=951c0082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951c0082",
  null
  
)

export default component.exports